
import Vue from 'vue'

export default Vue.extend({
  name: 'EyeSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
